// Carrega o iframe do vídeo ao clicar
$('body').on('click', '.video-load', function (ev) {
  ev.preventDefault();
  const $el = $(this);
  if (!$el.hasClass('video-loaded')) {
    const videoID = $el.data('video-id');
    const videoPlataform = $el.data('video-plataform');
    if (videoID != '' && videoPlataform != '') {
      $el.addClass('video-loaded');
      $el.html('');
      $el.append(createVideo(videoID, videoPlataform));
    }
  }
});

// Obtém o ID de um vídeo do Youtube através da URL
function YouTubeGetID(url) {
  url = url.split(/(vi\/|v%3D|v=|\/v\/|youtu\.be\/|\/embed\/)/);
  return undefined !== url[2] ? url[2].split(/[^0-9a-z_\-]/i)[0] : url[0];
}

// Obtém o ID de um vídeo do Vimeo através da URL
function VimeoGetID(url) {
  var id = false;
  $.ajax({
    url: 'https://vimeo.com/api/oembed.json?url=' + url,
    async: false,
    success: function (response) {
      if (response.video_id) {
        id = response.video_id;
      }
    },
  });
  return id;
}

// Retorna um objeto com as informações do vídeo
function parseVideo(url) {
  const videoObj = {};
  // Verifica a plataforma do vídeo
  if (/youtu/.test(url)) {
    videoObj.plataforma = 'youtube';
    videoObj.id = YouTubeGetID(url);
  } else if (/vimeo/.test(url)) {
    videoObj.plataforma = 'vimeo';
    videoObj.id = VimeoGetID(url);
  }
  return videoObj;
}

// Cria um elemento Iframe de vídeo
function createVideo(videoID, videoPlataform) {
  let $iframe;
  if (videoPlataform == 'youtube') {
    $iframe = `<iframe class="embed-item" src="https://www.youtube.com/embed/${videoID}?controls=1&autoplay=1" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
  } else if (videoPlataform == 'vimeo') {
    $iframe = `<iframe class="embed-item" src="https://player.vimeo.com/video/${videoID}?title=0&byline=0&portrait=0&autoplay=1" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>`;
  }
  return $iframe;
}

// Cria uma thumb para o video
function createVideoThumb(videoID, videoPlataform) {
  const thumbImage = getVideoThumb(videoID, videoPlataform);
  let $thumb = `<div class="embed-item embed-item-video" style="background-image: url('${thumbImage}')">
    <span class="embed-item-video-play">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"/></svg>
    </span>
  </div>`;
  return $thumb;
}

// Retorna a imagem da thumb do vídeo
function getVideoThumb(videoID, videoPlataform = 'youtube', thumbFile = '') {
  if (videoID != '') {
    if (videoPlataform == 'youtube') {
      const urlThumb = 'https://img.youtube.com/vi/' + videoID + '/';
      thumbFile = thumbFile != '' ? thumbFile : '0.jpg';
      return urlThumb + thumbFile;
    } else if (videoPlataform == 'vimeo') {
      return 'https://vumbnail.com/' + videoID + '.jpg';
    }
  }
  return false;
}
